import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { ArrowUpRight01Icon } from 'hugeicons-react';
var TableClickableItem = function (_a) {
    var text = _a.text, onClick = _a.onClick, _b = _a.showTooltip, showTooltip = _b === void 0 ? false : _b, tooltipContent = _a.tooltipContent, _c = _a.tooltipPlacement, tooltipPlacement = _c === void 0 ? 'top' : _c;
    var theme = useTheme();
    var content = (_jsxs(Box, { padding: '4px 9px', onClick: onClick, sx: {
            borderRadius: '500px',
            width: 'fit-content',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: theme.palette.action.hover
            }
        }, gap: 0.5, display: 'flex', alignItems: 'center', bgcolor: 'rgba(145, 158, 171, 0.16)', children: [_jsx(Typography, { variant: 'body2', color: theme.palette.text.primary, children: text }), _jsx(ArrowUpRight01Icon, { color: theme.palette.text.tertiary, width: 14, height: 14 })] }));
    if (showTooltip && tooltipContent) {
        return (_jsx(Tooltip, { title: tooltipContent, arrow: true, placement: tooltipPlacement, children: content }));
    }
    return content;
};
export default TableClickableItem;
